import { TranslateResult } from 'vue-i18n';

import { MatrixFormatError } from '@/models/matrix-format-error';
import { matrix } from '@/modules/matrix/observable';
import I18n from '@/plugins/i18n';
import { generateCsvContent } from '@/services/csv-generator';
import { getIsoFormattedDate } from '@/services/date-formater';
import { accessValue, getControlReportFieldTranslateKey } from '@/services/purchase-conditions';

function formatErrorToCSVLine({ field, message, purchaseCondition, acceptedValues }: MatrixFormatError): string {
  const { rowIndex, ean, ref, circuit } = purchaseCondition;
  let fieldTranslation: TranslateResult = '';
  let rejectedValue = '';
  if (field != null) {
    fieldTranslation = I18n.t(getControlReportFieldTranslateKey(field));
    rejectedValue = accessValue(purchaseCondition, field);
  }
  const circuitTranslation = I18n.t(`headers.circuits.${circuit}`);
  let csvLine = `${rowIndex},${ean},${ref},${circuitTranslation},${fieldTranslation},"${message}",${rejectedValue},`;
  if (acceptedValues) {
    csvLine += `"${acceptedValues}"`;
  }
  return csvLine;
}

export function csvFileName(index: number): string {
  if (!matrix.elements[index]) {
    throw new Error(`No matrix file found at index ${index}`);
  }

  const dateString = getIsoFormattedDate(Date.now(), true);

  const fileNameParts = matrix.elements[index].file.name.split('.');
  fileNameParts.pop();
  const csvFileName = fileNameParts.join('.');

  const csvProcess = I18n.t(`csvFileName.${matrix.currentProcess}`);

  return `${csvProcess}_${csvFileName}_${dateString}.csv`;
}

export function csvContent(index: number): string {
  if (!matrix.elements[index]) {
    throw new Error(`No matrix content not found at index ${index}`);
  }

  const headers = 'ligne,ean,refLM,circuit,colonne,anomalie,valeur rejetée,valeurs possibles';
  const report = matrix.elements[index]?.report.slice().sort(function (a, b) {
    return a.purchaseCondition.rowIndex - b.purchaseCondition.rowIndex;
  });

  return generateCsvContent(headers, report, formatErrorToCSVLine);
}
